<template lang="html">
  <SceneContent v-bind="$props"/>
</template>

<script>
  // @TODO add here fetch data for special process
  import SceneContent from '@/components/interview/SceneContent.vue'

  export default {
    name: 'process-interview-scene',

    props: {
      interview: {
        type: Object,
        default: null
      },
      vacancy: {
        type: Object,
        default: null
      },
      loading: {
        type: Boolean,
        default: false
      },

      fetch: {
        type: Function,
        default: () => {}
      }
    },

    components: {
      SceneContent
    }
  }
</script>

<style lang="scss" scoped>
</style>
